@if (hasText) {
  <button
    type="button"
    class="help-guidance-trigger"
    aria-haspopup="dialog"
    [attr.aria-expanded]="visible"
    (click)="open()"
  >
    <span class="material-symbols-outlined" aria-hidden="true">info</span>
    <span>{{buttonLabel}}</span>
  </button>

  <p-dialog
    [(visible)]="visible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [dismissableMask]="true"
    [closeOnEscape]="true"
    [style]="{ width: 'min(94vw, 52rem)' }"
    appendTo="body"
    styleClass="help-guidance-dialog"
  >
    <ng-template #header>
      <div class="help-guidance-heading">
        <span class="material-symbols-outlined" aria-hidden="true">info</span>
        <div>
          <h2>Guidance</h2>
          <p>Supporting information for this question</p>
        </div>
      </div>
    </ng-template>

    <div class="help-guidance-content">
      <app-help-text-links [text]="text"></app-help-text-links>
    </div>

    <ng-template #footer>
      <button type="button" class="btn-primary" (click)="close()">Close</button>
    </ng-template>
  </p-dialog>
}
